<template>
    <div class="badge_wall">
        <!-- 背景图 -->
        <div class="badge_wall-bg"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 14 + statusBarHeight + 'px'}">
            <Back 
                :clickHandle="handleClosePage"
                :innerText="localesPackage?.['badgewall_back']?.[localesEnv]"
            />
            <div class="top-tag" @click="MedelWallHandle(true)">
                <img
                    class="top-tag-champing"
                    :src="require('@/assets/images/YuliApp/badgeWall/icon_honor.png')"
                />
                <span>{{ localesPackage?.['badgewall_honor']?.[localesEnv] }}</span>
                <div class="top-tag-active" v-show="showMedelWallPageRedLight"></div>
            </div>
        </div>
        <!-- title -->
        <div class="titleView" :style="{paddingTop: 14 + statusBarHeight + 'px'}">
            <span>{{ localesPackage?.['badgewall_title']?.[localesEnv] }}</span>
            <div class="titleView-line"></div>
        </div>
        <!-- switch -->
        <div class="switch">
            <div class="switch-item" 
                 v-for="(item, index) in switchTabGroup" 
                 @click.capture="switchTabHandle(index)"
                 :class="{
                    [item.classOff]: true,
                    [item.classOn]: curTabNum == index,
                 }"
                 :key="item.name">
                 <!-- 图标亮 -->
                 <img
                    v-show="curTabNum == index"
                    :src="item.iconOnUrl"
                 />
                 <!-- 图标灭 -->
                 <img
                    v-show="!(curTabNum == index)"
                    :src="item.iconOffUrl"
                 />
                 <!-- 标题 -->
                 <span class="switch-item-text"
                       :class="{
                        'switch-item-text-on': curTabNum == index,
                        [item?.textClass]: localesEnv == 'ja'
                       }">
                    {{ `${item.name}` }}
                    <!-- <span class="switch-item-text-number">
                        {{ `(${numberFormat(item.nowNumber)}/${numberFormat(item.total)})` }}
                    </span> -->
                 </span>
                 <!-- 红点 -->
                 <div class="switch-item-redPoint" v-show="item.isShowRedPoint"></div>
            </div>
        </div>
        <!-- badgelist 节点完成后渲染 -->
        <div ref="badgelist_ref" 
             class="badgelist" 
             :style="{
                // marginTop: calc(@topHeight + @switchHeight + @screenTop);
                marginTop: `${statusBarHeight > 0 ? 48+60+statusBarHeight : ''}px`,
                maxHeight: `${statusBarHeight > 0 ? `calc(100vh - ${48+60+statusBarHeight+'px'})` : ''}`
             }"
             v-if="doneFlag >= 2" 
             @scroll="handleScroll">
            <BadgeCard class="badgelist-item" 
                       @handle="BadgeCardDetailHandle"
                       v-for="item in showGroup" 
                       v-show="item?.isShow"
                       :dataPackage="item"
                       :label="item.label"
                       :badgeIcon="item.badgeIcon"
                       :nowStar="item.nowStar"
                       :maxStar="item.maxStar"
                       :process="item.process"
                       :jianyu="item.jianyu"
                       :reward="item.reward"
                       :badgeStatus="item.state"
                       :time="item?.time"
                       :isYuli="item?.isYuli"
                       :address="item?.address"
                       :isOther="item?.isOther"
                       :key="item?.label"/>
            <!-- 数据缺省 -->
            <div class="badgelist-nodata" v-show="showGroup?.filter(item => item?.isShow)?.length <= 0">
                <img
                    :src="require('@/assets/images/YuliApp/badgeWall/robot/nodata-robot.png')"
                />
                <span>{{ isConnectWallet ? localesPackage?.['badgewall_default1']?.[localesEnv] : localesPackage?.['badgewall_default3']?.[localesEnv] }}</span>
            </div>
        </div>

        <!-- 挂载页 -->
        <MedelWallPage v-if="showMedelWallPage" 
                        @handle="MedelWallHandle" 
                        :DataBase="initData" 
                        :newBadgeFlag="showMedelWallPageRedLight"
                        :appUserInfo="appUserInfoLocal"
                        :RadarData="RadarData">
        </MedelWallPage>
        <BadgeCardDetailPage v-show="showBadgeCardDetailPage" 
                             :userInfo="currentUserInfo"
                             @handle="BadgeCardDetailHandle"
                             :data="currentBadgeCardDetail">
        </BadgeCardDetailPage>
        <ClaimPopup v-if="showClaimPopup" 
                    @handle="ClaimPopupHandle" 
                    :cur_popup_info="currentRewardInfo?.reward">
        </ClaimPopup>
        <AnimateBadge v-if="showAnimateBadge" 
                      @handle="AnimateBadgeHanlde"
                      :badgeData="currentRewardInfo">
        </AnimateBadge>
        <SharePage v-if="showSharePage" 
                   @handle="SharePageHanlde" 
                   :shareData="currentShareInfo">
        </SharePage>
    </div>
</template>
  
<script>
import { onBeforeMount, onMounted, ref, nextTick, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import { getAchievementList, getBadgeReward } from "@/api/badgeWall.js";
import BadgeCard from "./components/BadgeCard";
import MedelWallPage from "./components/MedelWallPage";
import BadgeCardDetailPage from "./components/BadgeCardDetailPage";
import ClaimPopup from "./components/ClaimPopup";
import AnimateBadge from "./components/AnimateBadge";
import SharePage from "./components/SharePage";
import Back from "@/components/universal/Back";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import { px2rem } from "@/utils/utils.js";
import { getTime } from "@/utils/utils";
import { getCurrentFormattedDate } from "@/utils/time.js";
// import audioManager from "@/utils/audioManager";
import _ from "lodash";
import { getBadgeWallLanguage } from "@/api/language.js";
import store from "@/store";

export default {
components: {
    BadgeCard,
    MedelWallPage,
    BadgeCardDetailPage,
    ClaimPopup,
    AnimateBadge,
    SharePage,
    Back
},
props: {
    id: {
        type: Number,
        default: 0,
    },
},
watch: {
    init: {
      async handler(value) {
        if (!value) {
          return;
        }
        await this.pageInit();
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        console.log('languageEnv: ', value);
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        console.log('languagePackage: ', value);
        if(value){
          this.localesPackage = value;
          this.initHandle();
        }
      },
      immediate: true,
      deep: true,
    },
    appUserInfo: {
      async handler(value) {
        if (!value) {
          return;
        }
        console.log("appUserInfo: ", value);
        this.appUserInfoLocal = value;
      },
      immediate: true,
      deep: true,
    },
},
data() {
    return {};
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
        appUserInfo: (state) => state.global.appUserInfo,
    }),
},
setup(props) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const switchTabGroup = ref([
        {
            iconOnUrl: require('@/assets/images/YuliApp/badgeWall/tabIcon/icon_summaryOn.png'),
            iconOffUrl: require('@/assets/images/YuliApp/badgeWall/tabIcon/icon_summaryOff.png'),
            classOn: 'switch-summary-on',
            classOff: 'switch-summary-off',
            name: 'Summary',
            nowNumber: 0,
            total: 0,
            isShowRedPoint: false,
        },
        {
            iconOnUrl: require('@/assets/images/YuliApp/badgeWall/tabIcon/icon_milestoneOn.png'),
            iconOffUrl: require('@/assets/images/YuliApp/badgeWall/tabIcon/icon_milestoneOff.png'),
            classOn: 'switch-milestone-on',
            classOff: 'switch-milestone-off',
            textClass: 'ja_longText',
            name: 'Milestone',
            nowNumber: 0,
            total: 0,
            isShowRedPoint: false,
        },
    ]);
    const dataGroup = ref([]);// 总数据
    const showGroup = ref([]);// 展示数据
    const initData = ref([]);// 原始接口数据
    const appUserInfoLocal = ref({
        "about": "", 
        "activation_code": "", 
        "avatar_url": "https://www.yuliverse.com/pre/images/xmas/75.png", 
        "birthday": 0, 
        "email": "userinfo error", 
        "is_set_password": false, 
        "register_day": 191, 
        "register_timestamp": 1679035914, 
        "rename_cd": 0, 
        "role_count": 0, 
        "sex": "female", 
        "state": "enabled", 
        "user_id": "xxxxxxxxx", 
        "username": "userinfo error", "virtual_url": "https://www.yuliverse.com/pre/images/virtual/3.png"
    })
    const currentShow = ref(1);
    const curTabNum = ref(0);
    const currentBadgeCardDetail = ref(null);
    const currentRewardInfo = ref(null);
    const currentUserInfo = ref({
        address: ''
    })
    const currentShareInfo = ref(null);
    const activityDays = ref(0); //活跃天数
    const medalTotalData = ref(null); //用户当前徽章数据
    const RadarData = ref([
        {
            name: 'YULI’s growth',
            max: 0,
            value: 0,
        },
        {
            name: 'Chip\nenhancement',
            max: 0,
            value: 0,
        },
        {
            name: 'Item\nsynthesis',
            max: 0,
            value: 0,
        },
        {
            name: 'COA',
            max: 0,
            value: 0,
        },
        {
            name: 'Hunt &\nCollection',
            max: 0,
            value: 0,
        },
        {
            name: 'Guide’s\ngrowth',
            max: 0,
            value: 0,
        },
    ]); // 雷达图数据
    // 展示页面
    const showClaimPopup = ref(false);
    const showMedelWallPageRedLight = ref(false);
    // 需要预加载的页面
    const showAnimateBadge = ref(false);
    const showMedelWallPage = ref(false);
    const showBadgeCardDetailPage = ref(false);
    const showSharePage = ref(false);
    // 额外标志位
    const doneFlag = ref(0);//加载完成标志 2 为完成 即使会展示数据列表， 也用于数据异步同步操作，但起始值要从2开始
    const rewardState = ref(null);//领取状态
    const reLinkTimes = ref(0); // 重连次数
    const badgelist_ref = ref(null); // 徽章列表ref
    const isConnectWallet = ref(true); // 是否关联钱包
    const nowShowPage = ref(null); // 当前展示二级页面
    // 二级页面map表
    const ShowPageMap = {
        AnimateBadge: 1,
        HonerWeekly: 2,
    }
    /**关键字段表 */
    const keyMap = {
        /**奖励奖品类型 */
        reward_type: {
            /**arg */
            1: {
                text: 'ARG',
                status: 1,
                url: require('@/assets/images/YuliApp/badgeWall/coin/Arg.png'),
            },
            /**art */
            2: {
                text: 'ART',
                status: 2,
                url: require('@/assets/images/YuliApp/badgeWall/coin/Art.png'),
            },
            /**g-arg */
            3: {
                text: 'G-ARG',
                status: 3,
                url: require('@/assets/images/YuliApp/badgeWall/coin/G-Arg.png'),
            },
            /**道具 */
            4: {
                text: '道具',
                status: 4,
            },
            /**头像 */
            5: {
                text: '头像',
                status: 5,
            },
            /**星尘 */
            6: {
                text: 'Stardust',
                status: 6,
                url: require('@/assets/images/YuliApp/badgeWall/coin/stardust.svg'),
            },
        }
    }

    onBeforeMount(async ()=>{
      appBridging.getSettingLaungage();
      appBridging.getUserInfo();
      const res = await getBadgeWallLanguage();
      store.dispatch("global/setLanguagePackage", res);// 存到stroe
    })

    onMounted(()=>{
        appBridging.getStatusBarHeight();
        nextTick(()=>{
            setTimeout(()=>{
                // 下一帧执行关闭loading
                nextTick(()=>{
                    const timer = setInterval(() => {
                        checkDom(timer, ()=>{
                            doneFlag.value++;
                            if(doneFlag.value >= 2){
                                console.log(`
                                 -=-=-=-=-=-=- load done -=-=-=-=-=-=-=-
                                 mobile-height: ${window.outerHeight},
                                 mobile-width: ${window.outerWidth},
                                `);
                                appBridging.closeLoading();                                                
                                window.clearInterval(timer);
                            }
                        });
                    }, 333);
                });
            },300);
        })
    });

    /**语言包初始化 */
    const initHandle = () => {
        let switchTabGroupLocal = _.cloneDeep(switchTabGroup.value);
        switchTabGroupLocal = switchTabGroupLocal.map((item, index) => {
            return{
                ...item,
                name: localesPackage.value?.[`badgewall_tab${index+1}`]?.[localesEnv.value]
            }
        })
        switchTabGroup.value = switchTabGroupLocal;
        let RadarDataLocal = _.cloneDeep(RadarData.value);
        RadarDataLocal = RadarDataLocal.map((item, index) => {
            return{
                ...item,
                name: localesPackage.value?.[`badgewall_radar${index+1}`]?.[localesEnv.value]
            }
        })
        RadarData.value = RadarDataLocal;
    }

    /**DOM节点渲染完成校验 */
    const checkDom = async (timer, fn = ()=>{}) => {
        console.log('document.readyState: ', document?.readyState);
        if(document?.readyState === 'complete'){
            fn();
            // window.clearInterval(timer);
        }
    }

    /**获取Achievement列表 */
    const requestGetAchievementList = async () => {
        proxy.$loading.show(); // 显示loading
        const res = await getAchievementList();
        // data-徽章数据，roles-yuli数据
        let { data, roles, address } = res;
        initData.value = res;
        currentUserInfo.value.address = address;
        // 过滤yuli数据 - 并处理总数据
        data = await rolesDataHandle(roles,data);
        // 徽章数据处理
        const switchDataGroup = [
            // 账号 - Summary
            {
                done: 0,
                total: 0,
                isShowRedPoint: false,
            },
            // yuli - Milestone
            {
                done: 0,
                total: 0,
                isShowRedPoint: false,
            },
        ];
        const group = [];
        data?.forEach(item => {
            const { abstract, children, details, id, name, medal_type, scene, isYuli, completed_count: parent_completed_count, yuliId } = item;
            if(id == '100'){
                // 获取活跃天数数据
                activityDays.value = parent_completed_count;
            }
            // 类目总共统计
            if(medal_type == 1){
                switchDataGroup[0].total++;
            }else{
                switchDataGroup[1].total++;
            }
            /**存储当前显示的进度 */
            const currentState = {};
            // 遍历子元素 - 计算每个子元素的state - 获取需要展示的星阶
            const childrenLength = children?.length || 0;
            for (let index = 1; index <= childrenLength; index++) {
                const childItem = children[index-1];
                const resState = getCompletedState(childItem, parent_completed_count);
                const { star, state, completed_count, max_progress, claimed_at, icon_url, reward, abstract, starId, address, starName, childScore } = resState;
                
                currentState.state = state;
                currentState.nowStar = star;
                currentState.currentNum = completed_count || item?.completed_count;
                currentState.total = max_progress;
                currentState.icon_url = icon_url;
                currentState.reward = reward;
                currentState.abstract = abstract;
                currentState.starId = starId;
                currentState.address = address;
                currentState.starName = starName;
                currentState.score = childScore;
                if(state == 2 && index !== childrenLength){
                    // 已领取，并且不是最后一个元素
                    // undo
                }else if(state == 0 || state == 1){
                    // 进行中，和可领取状态
                    // switch类目，已完成红点
                    if(medal_type == 1 && state == 1){
                        switchDataGroup[0].isShowRedPoint = true;
                    }else if(medal_type == 2 && state == 1){
                        switchDataGroup[1].isShowRedPoint = true;
                    }
                    break;
                }else{
                    // 都不符合，则是最后一个元素
                    currentState.time = claimed_at;
                    // switch类目，已完成统计
                    if(medal_type == 1){
                        switchDataGroup[0].done++;
                    }else{
                        switchDataGroup[1].done++;
                    }
                }
            }
            group.push({
                id: id,
                starId: currentState?.starId,
                label: currentState?.starName,
                medal_type: medal_type,
                badgeIcon: currentState?.icon_url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                nowStar: (currentState.state == 0 || currentState.state == 1) ? currentState.nowStar - 1 : currentState.nowStar,
                maxStar: children?.length || 1,
                process: {
                    currentNum: currentState.currentNum,
                    total: currentState.total
                },
                jianyu: currentState.abstract,
                details: currentState.abstract || details,
                reward: [
                    // 奖励道具
                    {
                        url: currentState?.reward?.url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                        name: currentState?.reward?.name,
                        number: currentState?.reward?.number,
                        type: currentState?.reward?.type,
                    },
                    // 成就分道具（前端模拟）
                    {
                        url: require('@/assets/images/YuliApp/badgeWall/coin/achievement_points_icon.png'),
                        name: 'Achievement Points',
                        number: currentState.score,
                        type: 4,
                    },
                ],
                state: currentState.state,
                time: currentState.time,
                isYuli: isYuli,
                yuliId,
                address: currentState.address,
                score: currentState.score,
                children: children?.map(item => {
                    return {
                        ...item,
                        completed_count: currentState.currentNum
                    }
                })
            })
        })
        // 总数据赋值前，做排序处理
        dataGroup.value = [];
        dataGroup.value = dataSortHandle(group);
        // 类目赋值
        const switchTabGroupLocal = _.cloneDeep(switchTabGroup.value);
        switchDataGroup.forEach((item, index) => {
            switchTabGroupLocal[index].nowNumber = item.done;
            switchTabGroupLocal[index].total = item.total;
            switchTabGroupLocal[index].isShowRedPoint = item.isShowRedPoint;
        })
        switchTabGroup.value = switchTabGroupLocal;
        
        showGroup.value = [];
        nextTick(async () => {
            // 根据类型渲染数据 
            showGroup.value = dataRenderHandle(dataGroup.value);
            try {
                // 二级页面情况 更新数据
                if(currentBadgeCardDetail.value !== false){
                    const currentShowItem = _.cloneDeep(currentBadgeCardDetail.value);
                    let index = -1;
                    if(currentShowItem?.yuliId){
                        // yuli
                        index = group.findIndex(item => item?.id == currentShowItem?.id && item?.yuliId == currentShowItem.yuliId);
                    }else{
                        // 普通
                        index = group.findIndex(item => item?.id == currentShowItem?.id);
                    }
                    if(index > 0){
                        currentBadgeCardDetail.value = group[index];
                    }
                    // console.log("inset group: ",group);
                }
            } catch (error) {
                console.log(error);
            }
            proxy.$loading.hide();
            // 运行 - 数据统计
            try {
                await statisticsAllBadge(data);
                await getBadgeClaimList(res);
            } catch (error) {
                console.log('统计发生错误');
            }
        })
    }

    const pageInit = async () => {
        try {
            // await requestGetBadgeDataList();
            await requestGetAchievementList();
            doneFlag.value++; // 完成进度增加
        } catch (error) {
            console.log(error);
            if(error?.response?.data?.msg == 'rpc error: code = Code(404420) desc = user is not bound wallet'){
                // 没绑钱包
                isConnectWallet.value = false;
                proxy.$loading.hide();
                return;
            }
            if(reLinkTimes.value < 3){
                proxy.$toast.show({
                  msg: `${localesPackage.value?.['katharsis_toast_msg2']?.[localesEnv.value]} ${reLinkTimes.value+1}.`,
                  type: TOAST_TYPE.ERROR,
                });
                setTimeout(()=>{
                    pageInit();
                    reLinkTimes.value++;
                },3333);
            }else{
                proxy.$toast.show({
                  msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
                  type: TOAST_TYPE.ERROR,
                })
                proxy.$loading.hide();
            }
        }
    }

    /**过滤-获取免费角色徽章数据 */
    const getRoleDataHandle = (yuliGroup, badgeData) => {
        // 角色映射表 key[role_type] -> condition_id
        const Role_Map = {
            100: 10, // zephyr
            101: 11, // aurora
        };
        // 获取角色数据组
        const roleDataGroup = yuliGroup?.filter(item => {
            const roleId = item.token_id;
            return Number(roleId) >= 1000000000 && Number(roleId) <= 2000000000;
        }) || [];
        // 获取角色类yuli徽章
        const roleBadge = badgeData?.filter(item => item.medal_type == 2 && item.scene == 6) || []; // yuli类角色徽章
        // 转角色数据 -> map存储
        const roleMap = {}; 
        roleDataGroup.forEach(item => {
            roleMap[Role_Map[item.role_type]] = item;
        })
        const res = [];
        roleBadge?.forEach(badgeItem => {
            const {condition_id } = badgeItem;
            const roleItem = _.cloneDeep(roleMap?.[condition_id]) || {};
            const { level, token_id } = roleItem;
            let { children } = badgeItem;
                // 各星阶遍历
                children?.forEach((starConfig,starIndex) => {
                    // 在已完成里 - 寻找星阶的role
                    const childYuliData = starConfig?.roles?.filter(yuli => yuli?.token_id == token_id) || null;
                    if(childYuliData?.length > 0){
                        // 如果找到
                        badgeItem.children[starIndex].is_claimed = true;
                        badgeItem.children[starIndex].completed_count = starConfig.max_progress;
                        badgeItem.children[starIndex].claimed_at = childYuliData?.[0].claimed_at || 0;
                        badgeItem.children[starIndex].address = childYuliData?.[0].address || 0;
                    }else{
                        // 没找到 - 代表没领取过
                        badgeItem.children[starIndex].is_claimed = false;
                        if(level >= starConfig.max_progress){
                            // 符合领取条件
                            badgeItem.children[starIndex].completed_count = level;
                        }else{
                            // 不符合领取条件
                            badgeItem.children[starIndex].completed_count = level;
                        }
                    }
                })
                res.push({
                    ...badgeItem,
                    // isYuli: {
                    //     id: '',
                    //     ...role,
                    //     role_type,
                    // }
                    yuliId: roleItem?.token_id
                })
        })
        return res;
    }

    /**处理Yuli数据，加入总数组 */
    const rolesDataHandle = async (yuliGroup, badgeData) => {
        // yuli数据处理
        const yuliBadge = badgeData?.filter(item => item?.condition_id <= 5) || []; // yuli徽章数组 - 限于等级类型关联
        // 获取角色类yuli徽章
        const roleBadgeData = getRoleDataHandle(yuliGroup, badgeData); // yuli类角色徽章
        // 转map存储
        const yuliBadgeMap = {}; 
        yuliBadge.forEach(item => {
            yuliBadgeMap[item.condition_id] = item;
        })
        const res = [];
        yuliGroup?.forEach(item => {
            const {claim_level, level, role_type, token_id } = item;
            if(role_type != 1){
                const yuliBadgeItem = _.cloneDeep(yuliBadgeMap?.[role_type - 1]) || {};
                let { children } = yuliBadgeItem;
                // 各星阶遍历
                children?.forEach((starConfig,starIndex) => {
                    // 在已完成里 - 寻找星阶的yuli
                    const childYuliData = starConfig?.roles?.filter(yuli => yuli?.token_id == token_id) || null;
                    if(childYuliData?.length > 0){
                        // 如果找到
                        yuliBadgeItem.children[starIndex].is_claimed = true;
                        yuliBadgeItem.children[starIndex].completed_count = starConfig.max_progress;
                        yuliBadgeItem.children[starIndex].claimed_at = childYuliData?.[0].claimed_at || 0;
                        yuliBadgeItem.children[starIndex].address = childYuliData?.[0].address || 0;
                    }else{
                        // 没找到 - 代表没领取过
                        yuliBadgeItem.children[starIndex].is_claimed = false;
                        if(level >= starConfig.max_progress){
                            // 符合领取条件
                            yuliBadgeItem.children[starIndex].completed_count = level;
                        }else{
                            // 不符合领取条件
                            yuliBadgeItem.children[starIndex].completed_count = level;
                        }
                    }
                })
                res.push({
                    ...yuliBadgeItem,
                    isYuli: {
                        id: token_id,
                        ...item,
                        role_type,
                    },
                    yuliId: token_id
                })
            }
        })
        // 处理总数组 - 去除所有yuli徽章
        res.push(...badgeData.filter(item => item?.medal_type == 1), ...roleBadgeData);
        return res;
    }

    /**获取星阶的状态(关联展示)*/
    const getCompletedState = (starItem, parent_completed_count = undefined) => {
        const { max_progress, is_claimed, star, claimed_at, icon_url, reward_type, reward_value, prop_info, abstract, id, address, name, score } = starItem;
        let { completed_count } = starItem;
        completed_count = parent_completed_count || completed_count;
        
        let res = {
            starName: name,
            starId: id,
            star: star,
            completed_count: completed_count || null,
            max_progress: max_progress,
            claimed_at: claimed_at,
            icon_url: icon_url,
            abstract: abstract,
            address: address,
            childScore: score,
        }
        let reward = {}
        // 奖品判断
        if(reward_type <= 3 || reward_type == 6){
            // 货币类
            reward = {
                url: keyMap.reward_type?.[reward_type]?.url,
                number: reward_value,
                type: 2,// 道具品质
                name: keyMap.reward_type?.[reward_type]?.text
            }
        }else if(reward_type == 4){
            // 道具
            reward = {
                url: prop_info?.img_url,
                number: reward_value,
                type: prop_info?.type == 2 ? Math.ceil(prop_info?.level / 2) : prop_info?.level,// 道具品质
                name: prop_info?.name
            }
        }else {
            // 头像类
            reward = {
                url: prop_info?.img_url,
                number: null,
                type: 1,// 道具品质
                name: 'avatar_url'
            }
        }
        res = {
            ...res,
            reward
        }
        // 最后state判断
        if(is_claimed){
            // 已领取
            return {
                ...res,
                state: 2
            }
        }else{
            // 未领取
            if(completed_count >= max_progress){
                // 已完成
                return {
                    ...res,
                    state: 1
                }
            }else{
                // 未完成
                return {
                    ...res,
                    state: 0
                }
            }
        }
    }

    /**数据排序 */
    const dataSortHandle = (dataGroup) => {
        const resData = dataGroup?.map(item => {
            // 根据item状态，赋予不同的权限等级
            const { state } = item;
            if(state == 0){
                // 未完成 - 进行中
                const {currentNum, total} = item?.process;
                // 默认权限 7 + 完成进度
                item.priority = 7 + (Number((currentNum / total).toFixed(4)) || 0);
            }else if(state == 1){
                // 已完成 - 待领取
                item.priority = 99;
            }else if(state == 2){
                // 已领取 - 基于特殊情况，按时间排序，
                const { time, address } = item;
                const currentTime = new Date().getTime(); //获取当前时间戳
                item.priority = (time || 0) - currentTime;
                // 如果这个奖励是别人领取的话
                if(!(currentUserInfo.value.address == address) && address){
                    item.priority -= currentTime;
                    item.isOther = true;
                }
            }
            return item;
        }) || [];
        // 按权限从大到小排序
        resData.sort((pre,next) => {
            // 将非数字值视为最小值，确保它们排在最后
            const priorityPre = typeof pre.priority === 'number' ? pre.priority : Number.MIN_SAFE_INTEGER;
            const priorityNext = typeof next.priority === 'number' ? next.priority : Number.MIN_SAFE_INTEGER;
            
            // 从大到小排序
            return priorityNext - priorityPre;
        });
        // console.log("resData2: ", resData);
        return resData;
    }

    /**数据渲染控制 */
    const dataRenderHandle = (dataGroup, overCardNumber = null) => {
        // const useOverCardNum = Math.floor(Math.abs(overCardNumber) || 0);// 已超过的子卡牌组
        // let nowChildIndex = 0;// 组别的子元素编号，从1开始使用
        // const visiableNumber = 8;// 初始可见度 8
        return dataGroup?.map(item => {
            if(item?.medal_type == curTabNum.value + 1){
                item.isShow = true;
                
                // 判断是否在展示范围 [可见度+超出值*4]
                // nowChildIndex++;
                // if(nowChildIndex <= (visiableNumber + useOverCardNum*4)){
                //     item.isShow = true;
                // }else item.isShow = false;
            }else item.isShow = false;
            return item;
        }) || [];
    }

    /**
     * 滑动监听处理
     */
     const handleScroll = () => {
        const scrollTop = badgelist_ref.value.scrollTop;  // 当前滚动高度
        const cardHeightRem = parseFloat(px2rem(340));// 获得卡牌高度，313 + marginB 10； 单位：rem
        const scrollTopRem = parseInt(px2rem(scrollTop));
        const overCardNumber = scrollTopRem / cardHeightRem;// 计算当前超过卡牌组 一组两张
        showGroup.value = dataRenderHandle(_.cloneDeep(dataGroup.value), overCardNumber);
    };

    /**数字格式化 */
    const numberFormat = (num) => {
        if (num < 10) {
            return '0' + num.toString();
        } else {
            return num.toString();
        }
    }

    /**切换控制器 */
    const switchTabHandle = (num) => {
        if(curTabNum.value == num) return;
        // audioManager.playEffect("secondmenu");
        curTabNum.value = num;
        showGroup.value = dataRenderHandle(dataGroup.value);
        // 拉回顶部
        badgelist_ref.value.scrollTop = 0;
        badgelist_ref.value.scrollTopRem = 0;
    }

    /**徽章墙显隐控制器（已领取） */
    const MedelWallHandle = async (state, data2) => {
        // audioManager.playEffect("bubble");
        if(state == 'share'){
            // 周报分享
            currentShareInfo.value = {
                pageType: 'HonerWeekly',
                username: appUserInfoLocal.value.username || '',
                user_avatar: appUserInfoLocal.value.avatar_url,
                achievementPoint: data2?.medalTotalData?.score,// 暂时写死等接口
                RadarData: data2?.RadarData || [],
                activityDays: activityDays.value,
                medalNumber: data2?.medalTotalData?.total || 0,
                useTotalPeople: data2?.medalTotalData?.useTotalPeople || 0,
                medalRank: data2?.medalTotalData?.userRankingData?.medalRank || null,
                pointRank: data2?.medalTotalData?.userRankingData?.pointRank || null,
                ...(currentRewardInfo.value || {
                    badgeIcon: require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                    label: 'badge name'
                }),
            }
            nowShowPage.value = ShowPageMap.HonerWeekly;
            showSharePage.value = true;
            return;
        }
        if(state == 'badgeShare'){
            // 徽章分享
            const badgeTotal = data2.medalTotalData?.total;
            currentShareInfo.value = {
                pageType: 'animateBadge',
                username: appUserInfoLocal.value.username || '',
                user_avatar: appUserInfoLocal.value.avatar_url,
                badgeTotal: badgeTotal,
                badgeCurrentDex: data2?.currentMedal?.currentDex || badgeTotal,
                achievementPoint: data2.medalTotalData?.score,
                ...data2.currentMedal,
                time: getTime((data2?.currentMedal.time * 1000), 'YYYY-MM-DD'),
            }
            nowShowPage.value = ShowPageMap.HonerWeekly;
            showSharePage.value = true;
            return;
        }
        if(state == 'medalTotalData'){
            medalTotalData.value = data2;
            return;
        }
        if(state == 'remove-red-point'){
            // 移除红点
            if(showMedelWallPageRedLight.value?.length > 0){
                if(data2?.yuliId){
                    showMedelWallPageRedLight.value = showMedelWallPageRedLight.value?.filter(item => {
                        return !(item.starId == data2.starId && item?.yuliId == data2?.yuliId)
                    })
                }else {
                    showMedelWallPageRedLight.value = showMedelWallPageRedLight.value?.filter(item => {
                        return item.starId != data2.starId
                    })
                }
            }else showMedelWallPageRedLight.value = false;
            if(showMedelWallPageRedLight.value?.length == 0)showMedelWallPageRedLight.value = false;
            return;
        }
        showMedelWallPage.value = state;
        if(state == false){
            // 关闭页面
            if(!(showMedelWallPageRedLight.value?.length > 0)){
                // 无残留时,取消红点高亮
                showMedelWallPageRedLight.value = false;
            }
        }
    }

    /**雷达数据统计处理函数 */
    const radarDataStatistics = (dataGroup, typeObj, score, toVal = 'max') => {
        // 映射表
        const typeMap = {
            // 账号徽章
            1: {
                // 卡牌
                1: 3,
                // 寻宝
                2: 4,
                // 芯片
                5: 1,
                // 合成
                8: 2,
            },
            // yuli徽章
            2: {
                // yuli等级
                1: 0,
                // 角色等级
                6: 5
            }
        }
        const { medal_type, scene } = typeObj;
        try {
            const typeMap2medal = typeMap[medal_type];
            if(typeMap2medal == null || typeMap2medal == undefined)return dataGroup;
            const typeMap2scene = typeMap2medal[scene];
            if(typeMap2scene == null || typeMap2scene == undefined)return dataGroup;
            dataGroup[typeMap2scene][toVal] += score;
        } catch (error) {
            console.log(error);
        }
        return dataGroup;
    }

    /**统计全部徽章 */
    const statisticsAllBadge = async (allData) => {
        // 雷达图总数据统计（峰值）
        let RadarDataGroup = _.cloneDeep(RadarData.value);
        allData?.forEach(badgeItem => {
            const { medal_type, scene, children } = badgeItem;
            children?.forEach(childrenItem => {
                const { score } = childrenItem;
                // 雷达总数据统计
                RadarDataGroup = radarDataStatistics(RadarDataGroup, {medal_type, scene}, score || 0);
            })
        })
        // 雷达图峰值赋值
        RadarData.value = RadarDataGroup;
    }

    /**
     * 获取已领取的徽章列表
     * @param {*} initData 
     */
    const getBadgeClaimList = async (initData) => {
        const getCompletedStateInner = (starItem) => {
            const { is_claimed, star, claimed_at, icon_url, name, score, prop_info, abstract } = starItem;
            let res = {
                name: name,
                star: star,
                nowStar: star,
                claimed_at: claimed_at,
                icon_url: icon_url,
                score
            }
            // 最后state判断
            if(is_claimed){
                // 已领取
                return {
                    ...res,
                    state: 2
                }
            }else{
                // 未领取
                return {
                    ...res,
                    state: 0
                }
            }
        }
        const { data, roles, address } = initData;
        // 过滤数据 -> 分类
        const normalBadgeGroup = data?.filter(item => item?.medal_type == 1); // 常规徽章数据组
        const yuliBadgeGroup = data?.filter(item => item?.medal_type == 2); // yuli徽章数据组
        /**最终渲染数组 */
        const endShowResGroup = [];

        // 常规徽章处理
        normalBadgeGroup?.forEach(badgeItem => {
            const { completed_count: parent_completed_count, medal_type, scene } = badgeItem;
            badgeItem?.children?.forEach(starItem => {
                const endRes = getCompletedStateInner(starItem);
                const { nowStar, state, claimed_at, name, icon_url, score } = endRes;
                if(state == 2){
                    // 已领取
                    endShowResGroup.push({
                        label: name,
                        badgeIcon: icon_url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                        nowStar: nowStar,
                        maxStar: badgeItem?.children?.length || 1,
                        time: claimed_at,
                        isYuli: null,
                        score,
                        medal_type,
                        scene
                    })
                }
            })
        })
        // yuli徽章数据组
        // yuli数据处理（含角色）
        const yuliBadgeMisson = yuliBadgeGroup?.filter(item => item?.condition_id <= 5 || item.scene == 6) || []; // yuli徽章数组 - 限于等级类型关联
        // 转map存储
        const yuliBadgeMap = {}; 
        yuliBadgeMisson.forEach(item => {
            yuliBadgeMap[item.condition_id] = item;
        })
        Object.keys(yuliBadgeMap).forEach(yuliBadgeKeys => {
            const badgeItem = yuliBadgeMap[yuliBadgeKeys];
            const { medal_type, scene } = badgeItem;
            // 匹配成功后 - 遍历徽章各个星阶 - 计算完成状态
            const group = yuliBadgeMap?.[yuliBadgeKeys]?.children;
            group?.forEach(starItem => {
                // 去寻找此星阶的完成组中，遍历
                starItem?.roles?.forEach( yuliItem => {
                    // 只进属于自己的徽章
                    if(address == yuliItem?.address)
                    endShowResGroup.push({
                        label: starItem?.name,
                        badgeIcon: starItem?.icon_url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                        nowStar: starItem?.star,
                        maxStar: group?.length || 1,
                        time: yuliItem?.claimed_at,
                        isYuli: {
                            id: yuliItem?.token_id,
                            role_type: yuliItem?.role_type
                        },
                        score: starItem?.score,
                        medal_type,
                        scene
                    })
                } )
            })
        })
        // 已领取的结果统计
        let scoreLocal = 0;
        let total = 0;
        let RadarDataGroup = _.cloneDeep(RadarData.value);
        endShowResGroup?.forEach(item => {
            const { medal_type, scene, score } = item;
            RadarDataGroup = radarDataStatistics(RadarDataGroup, {medal_type, scene}, score || 0, 'value');
            scoreLocal += score;
            total += 1; 
        })
        medalTotalData.value = {
            score: scoreLocal,
            total
        }
        // 雷达图用户值
        RadarData.value = RadarDataGroup;
        console.log('end: ', RadarData.value);
        return endShowResGroup;
    }

    /**徽章详情页 */
    const BadgeCardDetailHandle = async (state, packageData) => {
        console.log('BadgeCardDetailHandle state: ',state, 'packageData: ',packageData);
        // audioManager.playEffect("bubble");
        // 领取调用
        if(state == 'claim'){
            proxy.$loading.show(); // 显示loading
            doneFlag.value = 2;
            try {
                await rewardMainDo(packageData);
                proxy.$loading.hide(); // 关闭loading
            } catch (error) {
                showAnimateBadge.value = false;
                proxy.$toast.show({
                  msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
                  type: TOAST_TYPE.ERROR,
                })
                proxy.$loading.hide(); // 关闭loading
            }
            return;
        }
        showBadgeCardDetailPage.value = state;
        if(packageData){
            currentBadgeCardDetail.value = packageData;
        }
    }

    /**领取奖励主逻辑 */
    const rewardMainDo = async (packageData) => {
        const id = packageData?.isYuli?.id || packageData?.yuliId;
        const res = await getBadgeReward(packageData?.starId || '0', id);
        rewardState.value = res?.data; //{reward_value: 1}
        doneFlag.value++;
        // 领取成功
        appBridging.handleRefreshNativeCache('V1GetUProps');
        appBridging.handleRefreshNativeCache('V1GetChips');
        currentRewardInfo.value = packageData;
        showAnimateBadge.value = true;
        // 判断红点是否残留
        if(!showMedelWallPageRedLight.value) showMedelWallPageRedLight.value = [packageData];
        else showMedelWallPageRedLight.value.push(packageData);

        if(doneFlag.value == 4){
            animateBadgeDo();
        }
    }

    /**分享页控制 */
    const SharePageHanlde = async (state) => {
        const recoverPage = (page) => {
            if(page == ShowPageMap.AnimateBadge){
                showAnimateBadge.value = true;
            }
            currentShareInfo.value = null;
            nowShowPage.value = null;
        }
        if(state == 'close'){
            showSharePage.value = false;
            recoverPage(nowShowPage.value);
        }
    }

    /**徽章动画事件控制 */
    const AnimateBadgeHanlde = async (state) => {
        if(state == 'share'){
            currentShareInfo.value = {
                pageType: 'animateBadge',
                username: appUserInfoLocal.value.username || '',
                user_avatar: appUserInfoLocal.value.avatar_url,
                badgeTotal: (medalTotalData.value?.total || 0) + 1,
                ...(currentRewardInfo.value || {
                    badgeIcon: require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                    label: 'share error'
                }),
                time: getCurrentFormattedDate("YYYY/MM/DD"),
                achievementPoint: (medalTotalData.value?.score || 0) + currentRewardInfo.value.score,
            }
            // console.log("currentShareInfo: ", currentShareInfo.value);
            nowShowPage.value = ShowPageMap.AnimateBadge;
            showAnimateBadge.value = false;
            showSharePage.value = true;
            return;
        }
        if(state == 'anim-done'){
            // 徽章动画结束
            // nextTick(async ()=>{
            //     console.log('徽章动画结束');
            //     showAnimateBadge.value = false;
            //     showBadgeCardDetailPage.value = false;
            //     doneFlag.value++;
            //     if(doneFlag.value == 4){
            //         animateBadgeDo();
            //     }
            // });
        }else if(state == 'close'){
            // 关闭动画页面
            nextTick(async ()=>{
                showAnimateBadge.value = false;
                // showBadgeCardDetailPage.value = false;
                doneFlag.value++;
                if(doneFlag.value == 4){
                    animateBadgeDo();
                }
            });
        }
    }

    /**徽章动画结束后的逻辑 */
    const animateBadgeDo = async () => {
        // showClaimPopup.value = true; // 测试用
        if(rewardState.value?.reward_value > 0){
            // audioManager.playEffect("get_token");
            showClaimPopup.value = true;
        }else{
            proxy.$loading.show(); // 显示loading
            try {
                await requestGetAchievementList();
            } catch (error) {
                console.log(error);
            }
            proxy.$loading.hide(); // 关闭loading
        }
    }

    const ClaimPopupHandle = async (state) => {
        showClaimPopup.value = state;
        if(state == false){
            // 关闭领奖窗口 - 重新刷新页面
            proxy.$loading.show(); // 显示loading
            await requestGetAchievementList();
            proxy.$loading.hide(); // 关闭loading
        }
    }

    const handleClosePage = () => {
        appBridging.closePage();
    }

    return {
        handleClosePage,
        numberFormat,
        MedelWallHandle,
        BadgeCardDetailHandle,
        switchTabHandle,
        AnimateBadgeHanlde,
        SharePageHanlde,
        ClaimPopupHandle,
        pageInit,
        initHandle,
        handleScroll,
        showMedelWallPage,
        showBadgeCardDetailPage,
        showClaimPopup,
        showAnimateBadge,
        showSharePage,
        showMedelWallPageRedLight,
        curTabNum,
        currentBadgeCardDetail,
        currentRewardInfo,
        currentUserInfo,
        currentShareInfo,
        RadarData,
        appUserInfoLocal,
        switchTabGroup,
        dataGroup,
        showGroup,
        initData,
        doneFlag,
        badgelist_ref,
        isConnectWallet,
        localesPackage,
        localesEnv,
    };
},
};
</script>
  
<style lang="less" scoped>
    @topHeight: 48px;
    @titleHeight: 35px;
    @switchHeight: 52px;
    @screenTop: 18px;
    .badge_wall{
        position: fixed;
        top: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg,
            #A89E80 0%,
            #A39988 15%,
            #D0C6B6 50%,
            #B4AA99 82%,
            #AFA494 100%
        );
        &-bg{
            position: absolute;
            z-index: -1;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/MedelWallBg.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 12;
        width: 100%;
        height: @topHeight;
        // background-color: aqua;
        &-back{
            position: absolute;
            width: 44px;
            height: 44px;
            top: 50%;
            left: 0;
            transform: translate(0,-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-title{
            width: 106px;
            height: 19px;
            color: #ffffffff;
            font-size: 16px;
            font-weight: 500;
            font-family: "PingFang SC";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        &-tag{
            position: absolute;
            bottom: 40%;
            right: 0;
            transform: translate(0, 50%);
            font-size: 10px;
            width: 82px;
            height: 26px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 7px 4px;
            background: url("~@/assets/images/YuliApp/badgeWall/top_right_tag_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            &-champing{
                width: 20px;
                height: 20px;
                margin-right: 3px;
            }
            span{
                color: #ffffff;
                font-size: 10px;
                margin-top: 2px;
                margin-right: -4px;
            }
            &-active{
                width: 16px;
                height: 16px;
                background: url("~@/assets/images/YuliApp/badgeWall/RewardSignal.png") no-repeat
                top left;
                background-size: 100% 100%;
                position: absolute;
                top: -8px;
                right: 6px;
                z-index: 2;
            }
        }
    }
    .titleView{
        position: fixed;
        top: calc(@topHeight + 1px);
        left: 50%;
        transform: translateX(-50%);
        width: 346px;
        height: @titleHeight;
        z-index: 10;
        text-align: left;
        padding-left: 16px;
        color: #ffffff;
        font-family: "PingFang SC";
        font-size: 24px;
        font-weight: 600;
        line-height: 28.8px;
        &-line{
            width: 346px;
            height: 31px;
            position: absolute;
            left: 0;
            bottom: -8px;
            background: url("~@/assets/images/YuliApp/badgeWall/titleView-line.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
    }
    .switch{
        position: fixed;
        // top: @topHeight;
        bottom: 0;
        width: 100%;
        height: @switchHeight;
        background: #CBC2B2;
        box-sizing: border-box;
        z-index: 10;
        &-item{
            width: 50%;
            height: @switchHeight;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            position: relative;
            // padding-left: 24px;
            box-sizing: border-box;
            img{
                width: 22px;
                height: 22px;
                margin-right: 2px;
            }
            &-text{
                color: #DCDCDC;
                font-weight: 600;
                text-align: left;
                font-size: 18px;
                font-family: "PingFang SC";
                letter-spacing: -0.27px;
                &-number{
                    font-weight: 500;
                    font-size: 10px;
                    letter-spacing: -0.15px;
                    margin-left: -2px;
                }
                &-on{
                    color: #FFF8BB;
                }
            }
            &-redPoint{
                position: absolute;
                top: 2px;
                right: 8px;
                width: 16px;
                height: 16px;
                background: url("~@/assets/images/YuliApp/badgeWall/RewardSignal.png") no-repeat
                top left;
                background-size: 100% 100%;
            }
        }
        .ja_longText{
            font-size: 15px;
        }
        @bgWitdh: 52%;
        &-summary-off{
            background: url("~@/assets/images/YuliApp/badgeWall/summary_off.png") no-repeat
            top left;
            background-size: 100% 100%;
            position: absolute;
            width: @bgWitdh;
            left: 0;
        }
        &-milestone-off{
            background: url("~@/assets/images/YuliApp/badgeWall/milestone_off.png") no-repeat
            top left;
            background-size: 100% 100%;
            position: absolute;
            width: @bgWitdh;
            right: 0;
        }
        &-summary-on{
            background: url("~@/assets/images/YuliApp/badgeWall/summary_on.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
        &-milestone-on{
            background: url("~@/assets/images/YuliApp/badgeWall/milestone_on.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
    }
    .badgelist{
        @marginRight: 15px;
        @paddingLR: 22px;
        margin-top: calc(@topHeight + @screenTop + @titleHeight);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        // justify-content: space-around;
        // up right down left
        padding: 10px calc(@paddingLR - @marginRight) @switchHeight @paddingLR;
        width: 100%;
        height: fit-content;
        max-height: calc(100vh - calc(@topHeight + @switchHeight + @screenTop));
        box-sizing: border-box;
        overflow: scroll;
        &-item{
            // width: 45vw;
            margin-right: @marginRight;
            margin-bottom: 10px;
            // background-color: aqua;
        }
        &-nodata{
            margin: 0 auto;
            margin-top: 40%;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width: 150px;
                height: 150px;
                margin-bottom: -15px;
            }
            span{
                color: #7e83b5ff;
                font-size: 14px;
                font-weight: 400;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 18px;
            }
        }
    }
</style>